// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import AUTHORIZATION_CODE from '../../../enums/AuthorizationCode';

/**
 * @param root0
 * @param root0.authorizationCode
 * @returns {JSX} RenderAuthorizationCode
 */
function RenderAuthorizationCode({ authorizationCode }) {
    if (!authorizationCode) {
        return null;
    }

    return (
        <div className='flex flex-col items-center'>
            {
                <div>{authorizationCode}</div>
            }
            {
                authorizationCode in AUTHORIZATION_CODE &&
                <small className='ellipsis'>
                    <Entity entity={AUTHORIZATION_CODE[authorizationCode].entity} namespace={AUTHORIZATION_CODE[authorizationCode].namespace} />
                </small>
            }
        </div>
    );
}

RenderAuthorizationCode.propTypes = {
    authorizationCode: PropTypes.string
};


export default RenderAuthorizationCode;